enum MediaDevices {
    Video = "videoinput"
}

enum CameraDetectionScreens {
    RequestAccess = "requestAccess",
    Success = "success",
    NoCamera = "noCamera",
    Denied = "denied",
    Loading = "loading"
}

enum VideoAccess {
    NotRequested = "NotRequested",
    Granted = "Granted",
    Denied = "Denied"
}

export { MediaDevices, CameraDetectionScreens, VideoAccess };
